import { AssetClass } from "types/AssetClass";
import { AssetClassDistribution } from "types/AssetClassDistribution";
import { createCustomAction } from "typesafe-actions";

const ASSETCLASSDISTRIBUTION_DATA_LOAD = "ASSETCLASSDISTRIBUTION/ASSETCLASSDISTRIBUTION_DATA_LOAD";
const ASSETCLASSDISTRIBUTION_DATA_LOAD_SUCCESS =
  "ASSETCLASSDISTRIBUTION/ASSETCLASSDISTRIBUTION_DATA_LOAD_SUCCESS";
const ASSETCLASSDISTRIBUTION_DATA_LOAD_FAIL =
  "ASSETCLASSDISTRIBUTION/ASSETCLASSDISTRIBUTION_DATA_LOAD_FAIL";

export type AssetClassDistributionContentType = "all" | keyof typeof AssetClass;

export const load = createCustomAction(
  ASSETCLASSDISTRIBUTION_DATA_LOAD,
  (type) => (contentType: AssetClassDistributionContentType) => ({
    type,
    contentType,
  })
);

export const loadSuccess = createCustomAction(
  ASSETCLASSDISTRIBUTION_DATA_LOAD_SUCCESS,
  (type) => (contentType: AssetClassDistributionContentType, data?: AssetClassDistribution[]) => ({
    type,
    contentType,
    data,
  })
);

export const loadFail = createCustomAction(
  ASSETCLASSDISTRIBUTION_DATA_LOAD_FAIL,
  (type) => (contentType: AssetClassDistributionContentType, error?: string) => ({
    type,
    contentType,
    error,
  })
);
